import { toast } from "react-toastify";

const publicUrl = process.env.PUBLIC_URL || "";

export const LOGO_PATHS = {
  light: `${publicUrl}/light_logo.png`,
  dark: `${publicUrl}/dark_logo.png`,
};

/** Logo for resolved UI theme: light theme → light_logo, dark theme → dark_logo */
export function getThemeLogo(resolvedTheme) {
  return resolvedTheme === "dark" ? LOGO_PATHS.dark : LOGO_PATHS.light;
}

function getCssVar(name) {
  if (typeof document === "undefined") return "";
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
}

export const Data = {
  isDebug: true,
  get colorPrimary() {
    return getCssVar("--colorPrimary");
  },
  get colorSuccess() {
    return getCssVar("--colorSuccess");
  },
  projectName: "Admin",
  website: "",
  logoLight: LOGO_PATHS.light,
  logoDark: LOGO_PATHS.dark,
  /** @deprecated Use getThemeLogo(resolvedTheme) or ThemeLogo component */
  get logo() {
    return LOGO_PATHS.light;
  },
  get logoIc() {
    return LOGO_PATHS.light;
  },
  get logoIcon() {
    return LOGO_PATHS.light;
  },
  providerLink: "https://bsc-dataseed1.binance.org/",
  privateKey:
    "71a348e99a6b290dc2e3ce937fe96dbe3b39aeb62624df693d7a35e66f2753c8",
  testnetLink: "https://bscscan.com/address/",
};

export const MyDelay = (delayInms) => {
  return new Promise((resolve) => setTimeout(resolve, delayInms));
};
export const toastSuccess = (msg) => toast.success(msg);
export const toastFailed = (msg) => toast.error(msg);
